import { Box, Typography } from '@mui/material';
import BackButton from '../../components/Button/BackButton';

const NotFound = () => {

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
        padding: 3,
        textAlign: 'center'
      }}
    >
      <Typography variant="h1" component="h1" sx={{ fontSize: '6rem', fontWeight: 'bold' }}>
        404
      </Typography>
      <Typography variant="h4" component="h2" sx={{ mb: 2 }}>
        Página no encontrada
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, maxWidth: '600px' }}>
        Lo sentimos, la página que estás buscando no existe o ha sido movida.
      </Typography>
      <BackButton to="/" />
    </Box>
  );
};

export default NotFound; 